<!-- 档案操作日志 -->
<template>
  <div class="file-op-log-container">
    <!-- 按钮 -->
    <div class="code-staff-search">
      <el-input
        placeholder="档案名/昵称/手机号/卡号"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="getFileOpLogListParams.term"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <el-tag
        class="select-stafft-wrap"
        title="选择员工"
        :closable="searchMenNames.length === 0 ? false : true"
        @close="searchCloseTag"
        type="medium"
        effect="plain"
        @click="clickAddMember()"
      >
        <span v-if="searchMenNames.length === 0">选择员工</span>
        <span
          class="staff-names"
          v-for="(item, index) in searchMenNames"
          :key="index"
          >{{ item.name
          }}<span
            v-show="
              searchMenNames.length > 1 && index != searchMenNames.length - 1
            "
            >,</span
          ></span
        >
      </el-tag>
      <el-select
        v-model="getFileOpLogListParams.bindType"
        placeholder="操作类型"
        size="mini"
        @change="selectBindStatus"
        style="width: 140px; margin-right: 10px "
      >
        <el-option
          v-for="item in operationOptions"
          :key="item.bindStatus"
          :label="item.label"
          :value="item.bindStatus"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="getFileOpLogListParams.time"
        size="mini"
        :editable="false"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        range-separator="~"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="selectTime"
        clearable
        style="width: 240px;"
      >
      </el-date-picker>
    </div>
    <!-- 表格 -->
    <template>
      <el-table
        size="small"
        :data="tableData"
        fit
        highlight-current-row
        align="center"
        :header-cell-style="{ background: '#F9F9F9' }"
        height="calc(100vh - 238px)"
        ref="cusChatTable"
        style="font-size: 13px"
      >
        <el-table-column label="客户" min-width="250" >
          <!-- <template v-if="getFileOpLogListParams.bindType == 2">
            <div>
              全部客户
            </div>
          </template> -->
          <template slot-scope="scope">
            <!-- <div v-if="getFileOpLogListParams.bindType == 1">
              全部客户
            </div> -->
            <!-- <div > -->
              <el-row :gutter="20">
                <el-col :span="30" style="padding:0">
                  <el-avatar
                    size="medium"
                    shape="square"
                    :src="scope.row.avatar"
                  ></el-avatar>
                </el-col>
                <el-col :span="70">
                  <div style="color: black" v-if="scope.row.ctmName != null">
                    {{ scope.row.ctmName }}
                  </div>
                  <div style="color: black" v-else>无绑定职称</div>
                  <div style="color: #a09f9fc9; font-size: 12px;">
                    {{ scope.row.nickName
                    }}<span
                      style="color: rgb(70, 189, 10)"
                      v-if="scope.row.type == 1"
                    >
                      @微信</span
                    ><span style="color: rgb(8, 168, 231)" v-else>
                      @{{ scope.row.corpName }}</span
                    >
                  </div>
                </el-col>
              </el-row>
            <!-- </div> -->
          </template>
        </el-table-column>
        <el-table-column prop="ctmCode" label="卡号" min-width="200">
        </el-table-column>
        <el-table-column label="操作类型" min-width="150">
          <template slot-scope="scope">
            <div>
              <span>{{
                scope.row.bindType == 1 ? "档案绑定" : "档案解绑"
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="档案详情" min-width="120">
          <template slot-scope="scope">
            <el-button
              v-if="true"
              class="table-button"
              type="text"
              size="small"
              @click.stop="handleDetail(scope.$index, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="applyName"
          label="操作员工"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          min-width="200"
        ></el-table-column>
      </el-table>
    </template>
    <Pagination
      :childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- 添加人员树 -->
    <!-- <AddMemberView title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree
      title="选择成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
    <!-- 档案详情 -->
    <FileDetai
      :visiAble="detailVisiAble"
      :detailItem="detailParams"
      @closeDetail="closeDetail"
    ></FileDetai>
  </div>
</template>

<script>
import { fileOpLog } from "@/api/customer/fileOp.js";
// import AddMemberView from "@/views/code/components/addMember.vue"
import StaffTree from "@/components/staffTree/staffTree.vue";
import FileDetai from "@/views/customer/components/fileDetai.vue";
export default {
  components: {
    // AddMemberView,
    FileDetai,
    StaffTree,
  },
  data() {
    return {
      detailVisiAble: false,
      detailParams: {},
      tableData: [],
      dialogVisibleTree: false,
      currentSelectMember: [], // 当前选中的成员树
      getFileOpLogListParams: {
        term: "", // 模糊查询档案名/昵称/手机号/卡号
        bindType: "", // 操作类型 0解绑 1绑定
        userIdList: [], // 员工id集合
        time: [], // 操作时间范围
        pageNum: 1, // 页码 不传默认为1
        pageSize: 20, // 每页条数 不传默认为10
      },
      operationOptions: [
        {
          bindStatus: "",
          label: "全部",
        },
        {
          bindStatus: 1,
          label: "档案绑定",
        },
        {
          bindStatus: 0,
          label: "档案解绑",
        },
        // {
        //   bindStatus: 2,
        //   label: "导出档案",
        // },
      ],
      searchSelectTime: "",
      searchMenNames: [], //当前 搜索框-选中的成员
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
    };
  },
  created() {
    this.getApproveList(this.getFileOpLogListParams);
  },
  methods: {
    handleDetail(index, item) {
      item.detailType = 2;
      this.detailParams = JSON.parse(JSON.stringify(item));
      this.detailVisiAble = true;
    },
    // 关闭档案详情
    closeDetail() {
      this.detailVisiAble = false;
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    callBack(parm) {
      this.getFileOpLogListParams.pageNum = parm.currentPage;
      this.getFileOpLogListParams.pageSize = parm.pageSize;
      console.log("this.getFileOpLogListParams+++",JSON.stringify(parm));
      this.getApproveList(this.getFileOpLogListParams);
    },
    // 成员树的事件
    clickSubmitTree(val) {
      this.searchMenNames = [];
      this.currentSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.getFileOpLogListParams.userIdList = [];
      let arr = JSON.parse(JSON.stringify(val.sendArray));
      arr.forEach((item) => {
        let obj = {
          userId: item.userId,
          name: item.userName,
        };
        this.searchMenNames.push(obj);
        this.getFileOpLogListParams.userIdList.push(item.userId);
      });
      // 发送请求
      this.searchFn();
    },
    searchFn() {
      this.getFileOpLogListParams.pageNum = 1;
      this.getApproveList(this.getFileOpLogListParams);
    },
    // 搜索-添加成员
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.getFileOpLogListParams.userIdList = [];
      this.searchFn();
    },
    selectBindStatus(value) {
      this.getFileOpLogListParams.bindType = value;
      this.searchFn();
    },
    // 选择时间处理
    selectTime(dataTime) {
      if (dataTime == null) {
        this.getFileOpLogListParams.time = [];
      }
      this.searchFn();
    },
    // 获取档案操作日志
    getApproveList(params) {
      fileOpLog(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.pageparm.total = res.data.total;
            this.tableData = res.data.rows;
            this.pageparm.currentPage = this.getFileOpLogListParams.pageNum;
            this.pageparm.pageSize = this.getFileOpLogListParams.pageSize;
          } else {
            this.$message.error("获取档案操作日志失败,请重试！");
          }
        })
        .catch((action) => {
          this.$message.error("获取档案操作日志失败,请重试！");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.file-op-log-container {
  .code-staff-search {
    display: flex;
    margin-bottom: 15px;
    /deep/.select-stafft-wrap {
      margin-right: 10px;
      width: 180px;
      position: relative;
      cursor: pointer;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      .el-icon-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
      }
      .staff-names {
        color: #606266;
      }
    }
    .el-tag--plain {
      border-color: #dcdfe6;
      color: #c0c4cf;
    }
  }
}
</style>
